var isProduction = process.env.NODE_ENV === 'production';
var index = (function (condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    console.warn(message);
  }
});

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-warning/dist/tiny-warning.esm.js
// module id = 224
// module chunks = 0